<template>
  <div id="content" v-show="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form>
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
          <a v-if="!entity.active && $_updateActionAllowed"
             class="btn btn_action btn_grey btn_enable"
             :title="'Aktivovat' | translate"
             @click.prevent.stop="updateEntityActive('active', true)"
             v-translate>Aktivovat</a>
          <a v-if="entity.active && $_updateActionAllowed"
             class="btn btn_action btn_grey btn_disable"
             :title="'Deaktivovat' | translate"
             @click.prevent.stop="updateEntityActive('active', false)"
             v-translate>Deaktivovat</a>
          <a v-if="$_deleteActionAllowed"
             class="btn btn_action btn_delete"
             :title="'Smazat' | translate"
             @click.prevent.stop="deleteEntity"
             v-translate>Smazat</a>
        </p>
        <h1>{{entity.hostname}}</h1>
      </div>
      <tabs-wrapper>
        <tabs-list>
          <tabs-list-item
              v-for="item in responsiveTabs"
              :key="item.key"
              :item="item"
              :activate-class="getActiveTabClass(item.key)"
              @activate-tab="activateTab">
          </tabs-list-item>
        </tabs-list>
        <tabs-content v-show="isActiveTab('settings')">
          <section v-show="$_readActionAllowedAllOrOwnAndGlobal">
            <div class="left">
              <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <operator-select
                    v-model="operatorIdComputed"
                    :options="operatorOptions"
                    :disabled="true"
                >
                </operator-select>
              </div>
            </div>
          </section>
          <section>
            <div class="left">
              <detail-entity-info
              :entity="entity">
              </detail-entity-info>
              <div class="maintenance_box">
                <h3>Okna údržby:</h3>
                <ul v-if="entity.maintenance_windows && entity.maintenance_windows.length">
                  <li v-for="item in entity.maintenance_windows">
                    <a @click="goToMaintenanceWindowDetail($event, item.id)" :title="item.description">{{item.range}}</a>
                  </li>
                </ul>
                <ul v-else>
                  <li v-translate>Žádná okna údržby</li>
                </ul>
                <p v-if="$_updateActionAllowed"><a @click="$router.push({name: 'contentSourceMaintenanceWindowNewForContentSource', params: {idContentSource: entity.id}})" v-translate>Nové okno údržby</a></p>
              </div>
            </div>
            <div class="right">
              <div class="field_left">
                <text-input
                    id="hostname"
                    :required="true"
                    v-model="entity.hostname"
                    :disabled="disabled"
                    ref="hostnameref"
                >
                  <translate class="translate">Hostname</translate>
                </text-input>
                <text-input
                    id="ip"
                    v-model="entity.ip"
                    :disabled="disabled"
                    ref="ipref"
                >
                  <translate class="translate">IP adresa</translate>
                </text-input>
                <checkbox-input
                    id="virtualsource"
                    v-model="entity.virtual"
                    :disabled="disabled"
                >
                  <translate class="translate">Virtuální zdroj</translate>
                </checkbox-input>
              </div>
              <div class="field_right">
                <select-box
                    id="utilizationfactor"
                    v-model="entity.utilization_factor"
                    :options="utilizationFactorOptions"
                    :disabled="disabled"
                >
                  <translate class="translate">Vytížitelnost zdroje</translate>
                </select-box>
                <select-box-multi
                    id="locality"
                    v-model="entity.locality_ids"
                    :options="localityOptions"
                    :disabled="disabled"
                >
                  <translate class="translate">Lokalita</translate>
                </select-box-multi>
              </div>
              <div class="field_left">
                <date-picker edit-time
                             id="allow_video_data_delivery_from"
                             date-format="d. m. yy"
                             attrKey="allow_video_data_delivery_from"
                             v-model="entity.allow_video_data_delivery_from"
                             @update-date="updateContentSourceDate"
                             :disabled="disabled"
                >
                  <translate class="translate">Poskytovat obsah od</translate>
                </date-picker>
              </div>
              <div class="field_right">
                <date-picker edit-time
                             id="allow_video_data_delivery_to"
                             date-format="d. m. yy"
                             attrKey="allow_video_data_delivery_to"
                             v-model="entity.allow_video_data_delivery_to"
                             @update-date="updateContentSourceDate"
                             :disabled="disabled"
                >
                  <translate class="translate">Poskytovat obsah do</translate>
                </date-picker>
              </div>
            </div>
          </section>
          <section>
            <div class="left">
              <h2 v-translate>Backend konfigurace</h2>
              </div>
              <div class="right">
                <div class="field">
                  <JSONTextareaInput
                  v-model="entity.backend_config"
                  rows="15"
                  :disabled="disabled"
                  >
                    <translate class="translate">JSON konfigurace</translate>
                  </JSONTextareaInput>
                </div>
            </div>
          </section>

          <!-- LINEAR CONTENT -->

          <section class="padding-top">
            <div class="status">
              <h2 v-translate>Lineární obsah</h2>
              <a
                                    :title="'Přidat lineární obsah' | translate"
                  v-if="!disabled"
                  :class="['add', 'add_expand', { open: newLinearContentOpen }]"
                  @click.prevent="newLinearContentOpen = !newLinearContentOpen"
                  v-translate>Přidat lineární obsah
              </a>
            </div>
            <div
                :class="['filter', 'expand_content', { open: newLinearContentOpen }]"
                v-if="$_updateActionAllowed">
              <div class="field_left">
                <select-box
                    id="add-protocol"
                    ref="addprotocolref"
                    :required="true"
                    v-model="newLinearContent.id_protocol"
                    :options="protocolOptions"
                >
                  <translate class="translate">Protokol</translate>
                </select-box>
                <textarea-input
                    id="add-template-url"
                    ref="addtemplateref"
                    :required="true"
                    v-model="newLinearContent.template"
                    :options="[]"
                >
                  <translate class="translate">Template URL</translate>
                </textarea-input>
                <textarea-input
                    id="add-drm-license-url-template"
                    v-model="newLinearContent.drm_license_url_template"
                    :options="[]"
                >
                  <translate class="translate">DRM license URL template</translate>
                </textarea-input>
                <textarea-input
                    id="add-drm-certificate-url-template"
                    v-model="newLinearContent.drm_certificate_url_template"
                    :options="[]"
                >
                  <translate class="translate">DRM certificate URL template</translate>
                </textarea-input>
              </div>
              <div class="field_right">
                <checkbox-input
                    id="add-adaptive"
                    v-model="newLinearContent.adaptive"
                >
                  <translate class="translate">Adaptivní obsah</translate>
                </checkbox-input>
                <button-input @submit="addLinearContent"></button-input>
              </div>
            </div>
            <div class="table_overflow">
              <table class="vypis vypis_detail">
              <not-sorting-table-header
                  :titles="linearContentTableTitles"
                  :th-classes="{1:'template_url', 2:'template_url', 3:'template_url'}"
                  :use-right="false"
              ></not-sorting-table-header>
              <linear-content-row
                  v-for="item in entity.url_templates"
                  :is-editable="$_updateActionAllowed"
                  :item="item"
                  :key="item.id"
                  :protocol-options="protocolOptions"
                  @delete="deleteLinearContent"
                  @submit="updateLinearContent"
                  :ref="item.id + '-linearcontentrowref'">
              </linear-content-row>
            </table>
            </div>
          </section>

          <!-- NONLINEAR CONTENT -->

          <section>
            <div class="status">
              <h2 v-translate>Nelineární obsah</h2>
              <a
                  :title="'Přidat nelineární obsah' | translate"
                  v-if="!disabled"
                  :class="['add', 'add_expand', { open: newNonlinearContentOpen }]"
                  @click.prevent="newNonlinearContentOpen = !newNonlinearContentOpen"
                  v-translate>Přidat nelineární obsah
              </a>
            </div>
            <div
                :class="['filter', 'expand_content', { open: newNonlinearContentOpen }]"
                v-if="$_updateActionAllowed">
              <div class="field_left">
                <select-box
                    id="add-nonlinear-protocol"
                    :required="true"
                    v-model="newNonlinearContent.id_protocol"
                    :options="protocolOptions"
                >
                  <translate class="translate">Protokol</translate>
                </select-box>
                <text-input
                    id="add-nonlinear-timeshift"
                    ref="addtimeshiftref"
                    v-model="newNonlinearContent.timeshift_maximum_length_in_minutes"
                >
                  <translate class="translate">Max. délka TimeShiftu</translate>
                </text-input>
              </div>
              <div class="field_right">
                <text-input
                    id="add-nonlinear-catchup"
                    ref="addcatchupref"
                    v-model="newNonlinearContent.catchup_maximum_length_in_hours"
                >
                  <translate class="translate">Max. délka CatchUpu</translate>
                </text-input>
                <text-input
                    id="add-nonlinear-pvr"
                    ref="addpvrref"
                    v-model="newNonlinearContent.pvr_maximum_length_in_days"
                >
                  <translate class="translate">Max. délka nahrávek</translate>
                </text-input>
                <button-input @submit="addNonlinearContent"></button-input>
              </div>
            </div>
            <div class="table_overflow">
              <table class="vypis vypis_detail">
              <not-sorting-table-header
                  :titles="nonlinearContentTableTitles"
                  :use-right="false"
              ></not-sorting-table-header>
              <nonlinear-content-row
                  v-for="item in entity.nonlinear_content_settings"
                  :is-editable="$_updateActionAllowed"
                  :item="item"
                  :key="item.id"
                  :protocol-options="protocolOptions"
                  @delete="deleteNonlinearContent"
                  @submit="updateNonlinearContent"
                  :ref="item.id + '-nonlinearcontentrowref'"
              ></nonlinear-content-row>
            </table>
            </div>
          </section>
        </tabs-content>

        <!-- CONTENT -->

        <tabs-content v-show="isActiveTab('content')">
          <content-source-content-list
              :isEditable="$_updateActionAllowed"
              :content-source-id="entity.id"
              :content-items="entity.content"
              :url-templates="entity.url_templates"
              :protocol-names="protocolNames"
              :linear-protocol-ids="entity.linear_protocol_ids"
              :nonlinear-protocol-ids="entity.nonlinear_protocol_ids"
              :nonlinear-settings-allowed="nonlinearSettingsAllowed"
              :content-source-is-virtual="entity.virtual"
              @submit="updateContentRow"
              @delete-content-from-content-source="deleteContentFromContentSource"
              @delete-channel-from-content-source="deleteChannelFromContentSource"
          ></content-source-content-list>
        </tabs-content>
        <detail-bottom-buttons
            v-if=$_updateActionAllowed
            section-class="buttons"
            :show-link="true"
            :module-name="moduleName"
            @submit-form="submitForm"
        ></detail-bottom-buttons>
      </tabs-wrapper>
    </form>
  </div>
</template>

<script>
import contentSources from "./contentSources"
import detailActions from "@/components/mixins/detail-actions"
import TabsWrapper from "@/components/common/tabs/TabsWrapper"
import TabsList from "@/components/common/tabs/TabsList"
import TabsListItem from "@/components/common/tabs/TabsListItem"
import TabsContent from "@/components/common/tabs/TabsContent"
import NotSortingTableHeader from "@/components/common/NotSortingTableHeader"
import LinearContentRow from "@/components/views/contentsources/LinearContentRow"

import {prepareOptions, getFirstValue} from '@/utils/helpers'
import ButtonInput from "@/components/common/ButtonInput"
import NonlinearContentRow from "@/components/views/contentsources/NonlinearContentRow"
import ContentSourceContentList from "@/components/views/contentsources/content/ContentSourceContentList"
import JSONTextareaInput from "../../common/JSONTextareaInput";

export default {
  name: "ContentSourceDetail",
  components: {
    ContentSourceContentList,
    NonlinearContentRow,
    ButtonInput,
    LinearContentRow,
    NotSortingTableHeader,
    TabsContent,
    TabsListItem,
    TabsList,
    TabsWrapper,
    JSONTextareaInput
  },
  mixins: [detailActions, contentSources],
  data() {
    return {
      protocolNames: {},
      protocolOptions: [],
      newLinearContent: {id_protocol: null, template: '', drm_license_url_template: '', drm_certificate_url_template: '', adaptive: false},
      newLinearContentOpen: false,
      newNonlinearContent: {
        id_protocol: null,
        timeshift_maximum_length_in_minutes: null,
        catchup_maximum_length_in_hours: null,
        pvr_maximum_length_in_days: null,
      },
      newNonlinearContentOpen: false,
      linearContentId: null,
    }
  },
  created(
      ContentSourceService,
      OperatorService,
      ProtocolService,
      LocalityService,
      ContentSourceContentService,
      UrlTemplateService,
      ContentSourceNonlinearContentSettingsService
  ) {
    this.entityService = ContentSourceService
    this.protocolService = ProtocolService
    this.localityService = LocalityService
    this.contentSourceContentService = ContentSourceContentService
    this.urlTemplateService = UrlTemplateService
    this.contentSourceNonlinearContentSettingsService = ContentSourceNonlinearContentSettingsService

    this.createdInit()
        .then(() => {
          this.initUtilizationFactorOptions()
          this.initLocalityOptions(this.entity.id_operator)

          if (this.$_readActionAllowedAllOrOwnAndGlobal) {
            this.operatorService = OperatorService
            this.getOperators(true)
          }
        })

    this.protocolService.getSimpleEntities()
        .then(data => {
          let protocolNames = {}
          this._.forEach(data['protocols'], (protocol) => {
            protocolNames[protocol.id] = protocol.name
          })
          this.protocolNames = protocolNames
          this.protocolOptions = prepareOptions(data['protocols'], 'id', 'name')

          const firstProtocolId = getFirstValue(this.protocolOptions)
          this.newLinearContent.id_protocol = firstProtocolId
          this.newNonlinearContent.id_protocol = firstProtocolId
        })
  },
  beforeDestroy() {
    this.activateTab('settings')
  },
  computed: {
    linearContentTableTitles() {
      return [
        this.$gettext('Protokol'),
        this.$gettext('Template URL'),
        this.$gettext('DRM license URL template'),
        this.$gettext('DRM certificate URL template'),
        this.$gettext('Adaptivní obsah'),
      ]
    },
    nonlinearContentTableTitles() {
      return [
        this.$gettext('Protokol'),
        this.$gettext('Max. délka TimeShiftu'),
        this.$gettext('Max. délka CatchUpu'),
        this.$gettext('Max. délka uložení nahrávek')
      ]
    },
    disabled(){
      return !this.$_updateActionAllowed;
    },
    nonlinearSettingsAllowed() {
      let allowed = {
        'timeshift': [],
        'catchup': [],
        'pvr': []
      }
      this._.forEach(this.entity.nonlinear_content_settings, (settings) => {
        if (settings['timeshift_maximum_length_in_minutes'] !== null) {
          allowed['timeshift'].push(settings.id_protocol)
        }
        if (settings['catchup_maximum_length_in_hours'] !== null) {
          allowed['catchup'].push(settings.id_protocol)
        }
        if (settings['pvr_maximum_length_in_days'] !== null) {
          allowed['pvr'].push(settings.id_protocol)
        }
      })
      return allowed
    }
  },
  methods: {
    executePopupAction(value) {
      if (value === true) {
        if (this.getPopupAction === 'delete') {
          this.deleteEntity(false)
        }
        if (this.getPopupAction === 'delete-linear-content') {
          this.deleteLinearContent(this.getPopupId, false)
        }
        if (this.getPopupAction === 'delete-nonlinear-content') {
          this.deleteNonlinearContent(this.getPopupId, false)
        }
        if (this.getPopupAction === 'delete-content-from-content-source') {
          this.deleteContentFromContentSource(this.getPopupId, false)
        }
        if (this.getPopupAction === 'delete-channel-from-content-source') {
          this.deleteChannelFromContentSource(this.getPopupId, false)
        }
      }
      this.hidePopup()
    },

    // LINEAR CONTENT
    addLinearContent() {
      let params = {...this.newLinearContent, id_content_source: this.entity.id}
      this.urlTemplateService.addUrlTemplate(params)
          .then(() => {
            this.setSuccessMessage()
            this.resetNewLinearContentForm()
            this.resetContent()
            this.getEntity()
          })
          .catch(error => {
            this.setErrorMessage(this.processLinearContentErrorMessage(error))
          })
    },
    resetNewLinearContentForm() {
      this.successProcessLinearContent()
      this.newLinearContentOpen = false
      this.newLinearContent = {template: '', drm_license_url_template: '', drm_certificate_url_template: '', adaptive: false}
      this.newLinearContent.id_protocol = getFirstValue(this.protocolOptions)
      this.$refs['addtemplateref'].setTouched(false)
    },
    updateLinearContent(data) {
      const id = data['id']
      this._.unset(data, 'id')
      let params = {...data, id_content_source: this.entity.id}
      this.urlTemplateService.updateUrlTemplate(id, params)
          .then(() => {
            this.setSuccessMessage()
            this.successProcessLinearContent(id)
            this.resetContent()
            this.getEntity()
          })
          .catch(error => {
            this.setErrorMessage(this.processLinearContentErrorMessage(error, id))
          })
    },
    deleteLinearContent(data, showPopup = true) {
      if (showPopup) {
        this.showPopup(data, 'delete', 'delete-linear-content')
      } else {
        this.urlTemplateService.deleteUrlTemplate(data)
            .then(() => {
              this.setSuccessMessage()
              this.resetContent()
              this.getEntity()
            })
            .catch(error => {
              this.setErrorMessage(this.processLinearContentErrorMessage(error, data['id']))
            })
      }
    },

    // NONLINEAR CONTENT
    addNonlinearContent() {
      let params = this.processNonlinearSettingsParams({
        ...this.newNonlinearContent,
        id_content_source: this.entity.id
      })
      this.contentSourceNonlinearContentSettingsService.addEntity(params)
          .then(() => {
            this.setSuccessMessage()
            this.resetNewNonlinearContentForm()
            this.resetContent()
            this.getEntity()
          })
          .catch(error => {
            this.setErrorMessage(this.processNonlinearContentErrorMessage(error))
          })
    },
    resetNewNonlinearContentForm() {
      this.successProcessNonlinearContent()
      this.newNonlinearContentOpen = false
      this.newNonlinearContent = {
        timeshift_maximum_length_in_minutes: null,
        catchup_maximum_length_in_hours: null,
        pvr_maximum_length_in_days: null
      }
      this.newNonlinearContent.id_protocol = getFirstValue(this.protocolOptions)
    },
    updateNonlinearContent(data) {
      const id = data['id']
      this._.unset(data, 'id')
      let params = this.processNonlinearSettingsParams({...data, id_content_source: this.entity.id})
      this.contentSourceNonlinearContentSettingsService.updateEntity(id, params)
          .then(() => {
            this.setSuccessMessage()
            this.successProcessNonlinearContent(id)
            this.resetContent()
            this.getEntity()
          })
          .catch(error => {
            this.setErrorMessage(this.processNonlinearContentErrorMessage(error, id))
          })
    },
    deleteNonlinearContent(data, showPopup = true) {
      if (showPopup) {
        this.showPopup(data, 'delete', 'delete-nonlinear-content')
      } else {
        this.contentSourceNonlinearContentSettingsService.deleteEntity(data, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
            .then(() => {
              this.setSuccessMessage()
              this.resetContent()
              this.getEntity()
            })
            .catch(error => {
              this.setErrorMessage(this.processLinearContentErrorMessage(error, data['id']))
            })
      }
    },
    processNonlinearSettingsParams(params) {
      params['timeshift_maximum_length_in_minutes'] = this._.trim(params['timeshift_maximum_length_in_minutes'])
      params['catchup_maximum_length_in_hours'] = this._.trim(params['catchup_maximum_length_in_hours'])
      params['pvr_maximum_length_in_days'] = this._.trim(params['pvr_maximum_length_in_days'])

      if (params['timeshift_maximum_length_in_minutes'] === '') {
        params['timeshift_maximum_length_in_minutes'] = null
      }
      if (params['catchup_maximum_length_in_hours'] === '') {
        params['catchup_maximum_length_in_hours'] = null
      }
      if (params['pvr_maximum_length_in_days'] === '') {
        params['pvr_maximum_length_in_days'] = null
      }

      return params
    },

    resetContent() {
      this.entity['content'] = []
    },
    updateContentRow(data) {
      data = {id_operator: this.entity.id_operator, ...data}
      this.entityService.updateChannelSettingsInContentSource(this.entity.id, data)
          .then(() => {
            this.setSuccessMessage()
            this.getEntityAndUpdateEditedRow(data['id_channel'])
          })
          .catch(error => {
            if(error.hasOwnProperty('validation_errors') && error['validation_errors'].length){
              this.setErrorMessage(error['validation_errors'][0]);
            }else {
              this.setErrorMessage(error['error_message'])
            }
          })
    },
    getEntityAndUpdateEditedRow(idChannel) {
      this.setLoadingMessage()

      return this.entityService.getEntity(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
          .then(data => {
            this.emptyMessage()
            let localChannelRowKey = this.getChannelKey(idChannel, this.entity['content'])
            let remoteChannelRowKey = this.getChannelKey(idChannel, data[this.entityName]['content'])
            if (localChannelRowKey !== null && remoteChannelRowKey !== null) {
              this.entity['content'][localChannelRowKey] = data[this.entityName]['content'][remoteChannelRowKey]
              this.entity['content'] = this._.clone(this.entity['content'])
            }
          })
          .catch(error => {
            this.setErrorMessage(error['error_message'])
          })
    },
    getChannelKey(idChannel, contents) {
      let channelKey = null
      this._.forEach(contents, (content, key) => {
        if (idChannel === content.id_channel) {
          channelKey = key
        }
      })
      return channelKey
    },
    deleteContentFromContentSource(data, showPopup = true) {
      if (showPopup) {
        this.showPopup(data, 'delete', 'delete-content-from-content-source')
      } else {
        let params = {id_content_source: this.entity.id, ...data}
        this.contentSourceContentService.deleteEntity(params, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
            .then(() => {
              this.setSuccessMessage()
              this.getEntityAndUpdateEditedRow(data['id_channel'])
            })
            .catch(error => {
              this.setErrorMessage(this.processDeleteContentErrorMessage(error))
            })
      }
    },
    deleteChannelFromContentSource(data, showPopup = true) {
      if (showPopup) {
        this.showPopup(data, 'delete', 'delete-channel-from-content-source')
      } else {
        this.entityService.deleteChannelFromContentSource(this.entity.id, data)
            .then(() => {
              this.entityService.getEntity(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
                  .then((data) => {
                    this.setSuccessMessage()
                    this.entity['content'] = this._.clone(data[this.entityName]['content'])
                  })
                  .catch(error => {
                    this.setErrorMessage(error['error_message'])
                  })
            })
            .catch(error => {
              this.setErrorMessage(this.processDeleteContentErrorMessage(error))
            })
      }
    },
    goToMaintenanceWindowDetail(e, id) {
      this.$router.push({name: 'contentSourceMaintenanceWindowDetail', params: {id: id}})
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/contentsources/ContentSourceDetail.vue